import FetchClient, { type ApiResponse } from "./FetchClient";

// Mirrors the report written by server/cmd/free-after-cashback (-s3).

export interface FreeAfterCashbackHit {
  retailer: string;
  storeId: string;
  upc: string;
  name: string;
  image?: string;
  category?: string;
  msrp?: number;
  price: number;
  dgCoupon?: boolean;
  offerText?: string;
  walmartCash?: number;
  walmartCashQty?: number;
  walmartCashStacked?: boolean;
  ibottaOfferId?: string;
  ibottaOffer?: string;
  ibottaAmount?: number;
  ibottaQty?: number;
  ibottaExpires?: string;
  ibottaExpired?: boolean;
  ibottaSizeUnverified?: boolean;
  ibottaTerms?: string;
  effective: number;
  inStock: boolean;
  quantity?: number;
  lastUpdated: string;
  url?: string;
}

export interface FreeAfterCashbackStore {
  storeId: string;
  price: number;
  effective: number;
  inStock: boolean;
  quantity?: number;
  dgCoupon?: boolean;
}

export interface FreeAfterCashbackProduct {
  retailer: string;
  upc: string;
  name: string;
  image?: string;
  best: FreeAfterCashbackHit;
  storeCount: number;
  inStockStores: number;
  stores: string[];
  hits: FreeAfterCashbackHit[];
  carriedStores: number;
  carriedInStock: number;
  priceLow: number;
  priceHigh: number;
  allStores: FreeAfterCashbackStore[];
}

export interface FreeAfterCashbackReport {
  generatedAt: string;
  retailers: string[];
  days: number;
  maxPrice: number;
  includeExpired: boolean;
  stackWalmartCash: boolean;
  storesScanned: number;
  rowsRead: number;
  rowsWithIbotta: number;
  rowsWithCashback?: number;
  offersInMatcher: number;
  snapshotWrittenAt: string;
  failedQueries?: number;
  elapsedSeconds?: number;
  products: FreeAfterCashbackProduct[];
}

export async function getFreeAfterCashbackReport(refresh = false): Promise<FreeAfterCashbackReport | null> {
  const response = await FetchClient.get<ApiResponse<FreeAfterCashbackReport>>(
    `/admin/free-after-cashback${refresh ? "?refresh=1" : ""}`,
  );
  return response.data ?? null;
}
